import {
  MaestroActionTask,
  MaestroTaskProgress,
  MaestroTransportTask,
} from '@automata/api/apiSchemas';

export const isMaestroActionTask = (
  task: MaestroActionTask | MaestroTransportTask
): task is MaestroActionTask => 'is_manual_interaction' in task;

export const isMaestroTransportTask = (
  task: MaestroActionTask | MaestroTransportTask
): task is MaestroTransportTask => 'labware' in task;

export const taskRequiresManualInteraction = ({
  task,
}: MaestroTaskProgress): boolean =>
  isMaestroActionTask(task) && task.is_manual_interaction === true;
